import React from 'react';
import { API_HOST } from '../../constants/server.constant';
import Axios from 'axios';
import $ from 'jquery';

class ReverseDnsDashboard extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            rDNSList: [],
            totalRequest: 0,
            currDNSStatus: 0,
            currDNSId: "",
            currIdx: -1,
            isAction: false,
            message: "",
            msgType: "",
            showLoader: true,
            errorDisplay: false,
            isConfirm: false,
            emailToggle: true,
            typeToggle: false,
            statusToggle: false,
            userId: localStorage.getItem("userId")
        };
        this.handleInputs = this.handleInputs.bind(this);
    }

    componentDidMount = () => {
        document.styleSheets[1].disabled = true;
        this.loadCss();
    };
    componentWillUnmount() {
        document.styleSheets[1].disabled = false;
        var disbale1 = "bmrService-theme.css";
        var disbale2 = "bmrService-layout.css";
        var disbale3 = "bmrService-retina.css";
        var disbale4 = "bmrService-datepicker.css";
        Object.values(document.styleSheets).forEach(sheet => {
            let sheetLink = sheet.href;
            if(sheetLink !== null) {
                let urlLastName = sheetLink.split("/").pop();
                let sheetName = urlLastName.split("?");

                if(disbale1.indexOf(sheetName[0]) > -1) sheet.disabled = true;
                if(disbale2.indexOf(sheetName[0]) > -1) sheet.disabled = true;
                if(disbale3.indexOf(sheetName[0]) > -1) sheet.disabled = true;
                if(disbale4.indexOf(sheetName[0]) > -1) sheet.disabled = true;
            }

        });

    }
    loadCss = () => {
        document.title = "IDrive® Compute | IDrive Homepage";
        const link = document.createElement("link");
        link.href = "https://www.idrivecompute.com/bmr-service-infra/include/css/bmrService-theme.css?v=1.0";
        link.rel = "stylesheet";
        link.type = "text/css";
        document.head.appendChild(link);

        const link1 = document.createElement("link");
        link1.href = "https://www.idrivecompute.com/bmr-service-infra/include/css/bmrService-layout.css?v=1.0";
        link1.rel = "stylesheet";
        link1.type = "text/css";
        document.head.appendChild(link1);

        const link2 = document.createElement("link");
        link2.href = "https://www.idrivecompute.com/bmr-service-infra/include/css/bmrService-retina.css?v=1.0";
        link2.rel = "stylesheet";
        link2.type = "text/css";
        document.head.appendChild(link2);

        const link3 = document.createElement("link");
        link3.href = "https://www.idrivecompute.com/bmr-service-infra/include/css/bmrService-datepicker.css?v=1.0";
        link3.rel = "stylesheet";
        link3.type = "text/css";
        document.head.appendChild(link3);
        setTimeout(() => {
            this.setState({ showLoader: false });
        }, 300);
        this.getrDNSData();
    };

    getrDNSData = () => {
        this.setState({
            isAction: true
        });
        Axios.get(API_HOST + "/support/rdns/all").then(resp => {
            let data = resp.data;
            this.setState({
                rDNSList: data,
                totalRequest: data.length,
                isAction: false
            });
        }).catch(err => {
            this.setState({
                message: "Error while fetching details",
                errorDisplay: true,
                isAction: false,
                msgType: "error"
            });
        });
        this.setState({
            isAction: true
        });
    };


    handleInputs = (event, id, index) => {
        this.setState({
            errorDisplay: false,
            message: "",
            msgType: ""
        });
        var currentVal = $(event.currentTarget).closest('tr').find('.request-select option:selected').text();
        if(currentVal == "Pending") {
            this.setState({
                errorDisplay: true,
                message: "Selected status cannot be updated",
                msgType: "error"
            });
        }
        else {
            this.setState({
                isConfirm: true,
                currDNSId: id,
                currDNSStatus: (currentVal === "Approved" ? 1 : 2),
                currIdx: index
            });
        }
    };

    submitUpdate() {
        this.setState({
            isAction: true,
            isConfirm: false
        });
        let updatedStatusVal;
        if(this.state.currDNSStatus == 1) {
            updatedStatusVal = 1;
        }
        else {
            updatedStatusVal = 2;
        }

        let index = this.state.currIdx;
        let tempList = [...this.state.rDNSList];
        let tempObj = { ...tempList[index] };
        tempObj.status = this.state.currDNSStatus;
        tempList[index] = tempObj;
        Axios.put(API_HOST + "/support/rdns/updateStatus/" + updatedStatusVal + "/" + this.state.currDNSId + "/" + localStorage.getItem("userId"),
            {
                status: updatedStatusVal,
                email: tempObj.user.email,
                firstName: tempObj.user.firstName
            })
            .then(resp => {
                this.setState({
                    rDNSList: tempList,
                    isAction: false,
                    message: "RDNS status updated successfully",
                    errorDisplay: true,
                    msgType: "",
                });
            }).catch(err => {
                console.log(err);
                this.setState({
                    message: "Error while updating details",
                    errorDisplay: true,
                    msgType: "",
                    isAction: false
                });
            });
    }
    headerSortClick = (event) => {
        $('.sort_icon').removeClass('active');
        $(event.currentTarget).find('.sort_icon').addClass('active');
        $(event.currentTarget).find('.sort_icon').toggleClass('toggle_sort');
    };
    setSortable = (param) => {
        let items = [...this.state.rDNSList];

        if(param[0] == "email") {
            if(this.state.emailToggle) {
                items.sort(function (a, b) {
                    if(a.user.email < b.user.email) { return -1; }
                    if(a.user.email > b.user.email) { return 1; }
                    return 0;
                });

            }
            else {
                items.sort(function (a, b) {
                    if(a.user.email < b.user.email) { return 1; }
                    if(a.user.email > b.user.email) { return -1; }
                    return 0;
                });

            }
            this.setState({
                rDNSList: items,
                emailToggle: !this.state.emailToggle,
                typeToggle: false,
                ipToggle: false,
                statusToggle: false
            });
        }

        else if(param[0] == "type") {
            if(this.state.typeToggle) {
                items.sort(function (a, b) {
                    if(a.ipAddressType < b.ipAddressType) { return -1; }
                    if(a.ipAddressType > b.ipAddressType) { return 1; }
                    return 0;
                });

            }
            else {
                items.sort(function (a, b) {
                    if(a.ipAddressType < b.ipAddressType) { return 1; }
                    if(a.ipAddressType > b.ipAddressType) { return -1; }
                    return 0;
                });

            }
            this.setState({
                rDNSList: items,
                userIdToggle: false,
                typeToggle: !this.state.typeToggle,
                ipToggle: false,
                statusToggle: false
            });
        }
        else if(param[0] == "status") {
            if(this.state.statusToggle) {
                items.sort(function (a, b) {
                    if(a.status < b.status) { return -1; }
                    if(a.status > b.status) { return 1; }
                    return 0;
                });

            }
            else {
                items.sort(function (a, b) {
                    if(a.status < b.status) { return 1; }
                    if(a.status > b.status) { return -1; }
                    return 0;
                });

            }
            this.setState({
                rDNSList: items,
                userIdToggle: false,
                typeToggle: false,
                ipToggle: false,
                statusToggle: !this.state.statusToggle
            });
        }
    };


    render() {
        if(this.state.showLoader) {
            return (
                <div className="full_page_loader" style={ { display: this.state.showLoader ? "block" : "none" } }><div className="loader_icon"></div></div>
            );
        }
        return (
            <body>
                <div className="full_page_loader" style={ { display: this.state.isAction ? "block" : "none" } }><div className="loader_icon"></div></div>
                <div className={ this.state.msgType == "error" ? "common_user_message error" : "common_user_message success" } style={ { display: this.state.errorDisplay ? "block" : "none" } }>
                    <div className="message_content">
                        <p>{ this.state.message }</p>
                        <span className="close_icon" data-toggle="tooltip" title="" data-original-title="Close" onClick={ () => { this.setState({ errorDisplay: false, message: "" }); } }></span>
                    </div>
                </div>
                <header className="header">
                    <div className="inner-wrap" >
                        <div className="header-menu">
                            <ul>
                                <li style={ { display: "none" } }>Request ID: b_bmrService </li>
                                <li style={ { display: "none" } }>|<a className="edit_profile" href="#">Change Password</a></li>
                                <li className="logout" style={ { display: "none" } }><a href="bmrServiceLogout">Logout</a></li>
                            </ul>
                        </div>
                        <a className="logo" href="https://www.idrivecompute.com" target="_blank"></a>
                    </div>

                </header>
                <section>
                    <div className="dashboard-wrap">
                        <div className="clear"></div>
                        <section className="rgt-wrap">
                            <div className="lft-link-wrap">
                            </div>
                            <div className="inside-wrap">
                                <div className="con-satatic">
                                    <a name="sales-report" id="sales-report"> </a>
                                    <div className="con-title">
                                        <div className="common_msg error_msg" style={ { display: "none" } }>
                                            <p>{ this.state.message }</p>
                                            <a className="close_info" href="#" onClick={ (e) => { e.preventDefault(); this.setState({ errorDisplay: false, message: "" }); } }><img width="16" height="16" title="Close" alt="close" src="https://www.idrivecompute.com/bmr-service-infra/include/images/close.png" /></a>
                                        </div>
                                        <div className="brd-box">
                                            <div className="sales-table">
                                                <div className="sales-tableHead">
                                                    <div className="dashboard-title">
                                                        <h1>RDNS Status Tracking Dashboard</h1>
                                                    </div>
                                                    <div className="reports-view">
                                                        <ul>
                                                            <li className="totalUsers"> Total Request(s): <span>{ this.state.totalRequest }</span> </li>
                                                        </ul>
                                                    </div>
                                                </div>
                                                <div className="clear"></div>
                                                <div className="scroll-wrap">
                                                    <div className="scroll-box">
                                                        <table className="report-table" cellSpacing="0">
                                                            <thead className="table-header">
                                                                <tr>
                                                                    <th className="col col-email" onClick={ (event) => { this.headerSortClick(event); this.setSortable(["email"]); } }>Email ID<span className="sort_icon active"></span></th>
                                                                    <th className="col col-region" >IP</th>
                                                                    {/* <th className="col col-plan" >Plan</th> */ }
                                                                    <th className="col col-type" onClick={ (event) => { this.headerSortClick(event); this.setSortable(["type"]); } }>Type<span className="sort_icon"></span></th>
                                                                    <th className="col col-crdate">RDNS</th>
                                                                    <th className="col col-status" onClick={ (event) => { this.headerSortClick(event); this.setSortable(["status"]); } }>Status<span className="sort_icon"></span></th>
                                                                    <th className="col col-action">Action</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody className="table-inner-wrap">
                                                                { this.state.rDNSList.map((item, index) =>
                                                                    <tr key={ index } className={ item.status === 0 ? "pending_requested" : item.status === 1 ? "available_requested" : "cancel_requested" }>
                                                                        <td className="col col-email" title={ item.user.email }>
                                                                            <div className="email-blk">
                                                                                <div className="email_icon"><span>{ item.user.email.charAt(0).toUpperCase() }</span></div>
                                                                                <p><a href="#" onClick={ e => e.preventDefault() }>{ item.user.email }</a></p>
                                                                            </div>
                                                                        </td>
                                                                        <td className="col col-region" title={ item.ipAddress }>
                                                                            <p>{ item.ipAddress }</p>
                                                                        </td>
                                                                        {/* <td className="col col-plan">
                                                            <p>{ipAddressType}</p>
                                                        </td> */}
                                                                        <td className="col col-type">{ item.ipAddressType }</td>
                                                                        {/* <ReactTooltip id="rdnsTooltip" place="top" effect="solid">{item.rdns}</ReactTooltip> */ }
                                                                        <td className="col col-crdate" title={ item.rdns }>{ item.rdns }</td>
                                                                        { item.status === 0 ?
                                                                            <td className="col col-status pending" id="statusTD">

                                                                                <div className="table-dropdown">
                                                                                    <label className="request-dropdown">
                                                                                        <select className="request-select" name="bmStatus" size="1">
                                                                                            <option value="pending" selected>Pending</option>
                                                                                            <option value="available">Approved</option>
                                                                                            <option value="canceled">Rejected</option>
                                                                                        </select>
                                                                                    </label>
                                                                                </div>
                                                                            </td>
                                                                            :
                                                                            item.status == 1 ?
                                                                                <td className="col col-status available">Approved</td>
                                                                                : <td className="col col-status cancel">Rejected</td>

                                                                        }

                                                                        <td className="col col-action">
                                                                            { item.status === 0 ?
                                                                                <button className="btn btn_blue" onClick={ (e) => this.handleInputs(e, item.id, index) }>Update Request</button> : "" }
                                                                        </td>
                                                                    </tr>
                                                                ) }

                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                        <footer>
                            <div className="wrapper">
                                <p>&copy;IDrive Inc.</p>
                            </div>
                        </footer>
                    </div>
                </section>
                <div className="master_wrapper update_request_popup" style={ { display: this.state.isConfirm ? "block" : "none" } }>
                    <div className="shadow_container"></div>
                    <div className="popup_wrapper">
                        <div className="first_pos_container">
                            <div className="sec_pos_container">
                                <div id="" className="popup_container update_request main_acc_cancel popLeft" style={ { display: "block" } }>
                                    <form action="" method="post" name="cancel">
                                        <section className="popup_header">
                                            <h2 className="">Confirmation</h2>
                                            <span className="popup_close_btn hide_popup" onClick={ () => { this.setState({ isConfirm: false }); } }></span>
                                        </section>
                                        <section className="popup_content">
                                            <div className="update_request_box">
                                                <p style={ { display: "none" } } id="" className="err_msg"></p>
                                                <div className="editPro">
                                                    <div className="row-span pass_hide" style={ { display: "block" } }>
                                                        <p className="row_description">Selected RDNS request will be updated as { this.state.currDNSStatus === 1 ? "Approved" : "Rejected" }</p>

                                                    </div>


                                                    <div className="row-span fb_row" style={ { display: "block" } }>
                                                        <div className="footer_box">

                                                            <div className="fb_row1_cancel">
                                                                <div className="fb_row1" >
                                                                    <input type="button" className="red_btn" value="Cancel Request" />
                                                                </div>
                                                            </div>

                                                            <div className="fb_row2">
                                                                <input type="button" className="cancl" value="Cancel" onClick={ () => { this.setState({ isConfirm: false }); } } />
                                                                <input type="button" className="send submit" value="Confirm" onClick={ () => this.submitUpdate() } />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </section>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </body>
        );
    }
}

export default ReverseDnsDashboard;